<template>
  <div class="bg-[#fff] h-[100vh]">
    <dg-head>
      <div class="flex items-center">
        <p class="cursor-pointer pr-[40]" @click="push({ path: '/login' })"><i class="icon">&#xe6c4;</i> 登录</p>
        <a :href="ENV.official" target="_blank"> <el-button size="mini" type="primary">返回首页</el-button></a>
      </div>
    </dg-head>
    <div class="min-h-[84vh] pt-[100] md:pt-[50] md:min-h-[81vh]">
      <div class="w-[400] mx-[auto] md:zoom-[0.9]">
        <div class="flex justify-between mb-[24]">
          <p class="t-[24] t-[#192530] font-500">注册</p>
          <!-- <div class="flex  overflow-hidden cursor-pointer rounded-[2] leading-[32] text-center">
            <p class="w-[80] border-[#dcdfe6] border-y-[1px]  border-l-[1px] border-solid"
              :class="{ 't-[#fff] bg-[theme] border-[theme]': registerType == 1 }" @click="registerType = 1">企业</p>
            <p :class="{ 't-[#fff] bg-[theme] border-[theme]': registerType == 0 }" @click="registerType = 0"
              class="w-[80] border-[#dcdfe6] border-y-[1px] border-r-[1px] border-solid">自然人</p>
          </div> -->
        </div>
        <dg-alert-box>
          <el-form :model="registerForm" ref="registerFormRef" label-width="1px">
            <el-form-item label="" prop="enterpriseName" :rules="rules.enterpriseName" class="relative mb-[24]" v-if="registerType == 1">
              <!--   -->
              <el-input size="large" class="large_input" placeholder="*请填写注册的企业名称" v-model="registerForm.enterpriseName"> </el-input>
              <p class="t-[12] t-[#a1a1a1] absolute leading-[20] right-[0]">请与营业执照保持一致</p>
            </el-form-item>
            <el-form-item label="" prop="enterpriseCode" :rules="rules.enterpriseCode" class="relative mb-[24]" v-if="registerType == 1">
              <el-input size="large" class="large_input" placeholder="*请填写统一社会信用代码" v-model="registerForm.enterpriseCode"> </el-input>
              <p class="t-[12] t-[#a1a1a1] absolute leading-[20] right-[0]">请与营业执照保持一致</p>
            </el-form-item>
            <template v-if="registerType == 0">
              <el-form-item label="" prop="name" :rules="[{ required: true, message: registerType == 0 ? '请填写姓名' : '请填写经办人姓名' }]" class="relative mb-[24]">
                <el-input size="large" class="large_input" :placeholder="registerType == 0 ? '*请填写姓名' : '*请填写经办人姓名'" v-model="registerForm.name"> </el-input>
              </el-form-item>
              <el-form-item
                label=""
                prop="mobile"
                class="relative mb-[24]"
                :rules="[
                  { required: true, message: '请填写手机号' },
                  { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请填写手机号' },
                ]"
              >
                <el-input size="large" class="large_input" placeholder="*请填写手机号" maxlength="11" v-model="registerForm.mobile"> </el-input>
              </el-form-item>
            </template>
            <div class="flex justify-between" v-else>
              <el-form-item label="" prop="name" :rules="[{ required: true, message: registerType == 0 ? '请填写姓名' : '请填写经办人姓名' }]" class="relative mb-[24] w-[164]">
                <el-input size="large" class="large_input" :placeholder="registerType == 0 ? '*请填写姓名' : '*请填写经办人姓名'" v-model="registerForm.name"> </el-input>
              </el-form-item>
              <el-form-item
                label=""
                prop="mobile"
                class="relative mb-[24] w-[226]"
                :rules="[
                  { required: true, message: '请填写手机号' },
                  { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请填写手机号' },
                ]"
              >
                <el-input size="large" class="large_input" placeholder="*请填写手机号" maxlength="11" v-model="registerForm.mobile"> </el-input>
              </el-form-item>
            </div>
            <el-form-item label="" prop="password" :rules="rules.password" class="relative mb-[24]">
              <el-input size="large" class="large_input" @focus="intensityVisible = true" @blur="intensityVisible = false" placeholder="*请设置登录密码" show-password v-model="registerForm.password"> </el-input>

              <dg-pasw-intensity v-show="intensityVisible" :value="registerForm.password"></dg-pasw-intensity>
            </el-form-item>

            <el-form-item label="" class="mb-[24]" prop="catchcode" :rules="[{ required: true, message: '请输入图形码' }]">
              <div class="flex">
                <div class="relative flex-1 pr-[10]">
                  <el-input size="large" class="large_input" placeholder="请输入图形码" v-model="registerForm.catchcode"> </el-input>
                </div>
                <div class="verificationCode w-[130] pl-[10]" @click="getcaptcha">
                  <img :src="verificationCode" class="w-[100%] h-[48]" alt="" />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="" prop="smsCode" :rules="[{ required: true, message: '请输入短信验证码' }]" class="mb-[24]">
              <el-input size="large" class="large_input" placeholder="请输入短信验证码" v-model="registerForm.smsCode">
                <template v-slot:suffix>
                  <div class="suffix cursor-pointer border-l-[1] border-[#d5dae5] border-solid w-[100] leading-[24] my-[9] t-[theme]" @click="handleSend">{{ CountDownStatus ? "发送短信" : `${CountDownNum}/s` }}</div>
                </template>
              </el-input>
            </el-form-item>
            <div class="t-[12]"><el-checkbox v-model="isProtocol"></el-checkbox> <span>同意</span> <a v-for="(v, index) in protocol" :key="index" :href="`#/protocolRegister?id=${v.id}`" target="_blank" class="!t-[theme] mr-[5] no-underline">《{{v.title}}》</a></div>
            <div class="mt-[14]">
              <el-button class="w-[100%]" type="primary" @click="handleregister('registerFormRef')">注册</el-button>
            </div>
          </el-form>
        </dg-alert-box>
      </div>
    </div>
    <dg-copyright></dg-copyright>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import { deepCopyRef, encryptDES } from "@/assets/js/utils";
import CountDown from "@/assets/js/countDown";
export default {
  mixins: [mixin],
  data() {
    // ^.{3,20}$
    var enterpriseName = (rule, value, callback) => {
      // { required: registerTypeIndex == 1, message: '请填写注册的企业名称' }
      if (value === "") {
        callback(new Error("请填写注册的企业名称"));
      } else if (value.replace(/[^\u0000-\u00ff]/g, "aa").length < 8) {
        callback(new Error("企业名称最少8个字符"));
      } else {
        callback();
      }
    };
    // ^((\d{18})|([0-9x]{18})|([0-9X]{18}))$
    var enterpriseCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写统一社会信用代码"));
      } else if (!/^[A-Za-z0-9]{18}$/.test(value)) {
        callback(new Error("社会统一信用代码为18位数，大小字母和数字组成"));
      } else {
        callback();
      }
    };
    var password = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请设置登录密码"));
      } else if (!/^(?!.*(.)\1{2,})(?=.*[a-zA-Z].*[0-9]|[a-zA-Z].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]|[0-9].*[!@#$%^&*()_+[\]{};':"\\|,.<>?`~]).{6,32}$/.test(value)) {
        callback(new Error("设置密码格式错误"));
      } else {
        callback();
      }
    };

    // ^[A-Za-z0-9]+$
    return {
      rules: {
        enterpriseName: [{ required: true, validator: enterpriseName, trigger: "blur" }],
        enterpriseCode: [{ required: true, validator: enterpriseCode, trigger: "blur" }],
        password: [{ required: true, validator: password, trigger: "blur" }],
      },
      registerType: 1,
      protocol: [],
      CountDownNum: 60,
      intensityVisible: true,
      CountDownStatus: true,
      isProtocol: true,
      verificationCode: "",
      registerTypeData: [
        { type: 0, name: "自然人", api: "/supplyChain/auth/personRegist" },
        { type: 1, name: "企业", api: "/supplyChain/auth/enterpriseRegist" },
      ],
      registerForm: {
        enterpriseCode: "", // 企业统一信用代码
        enterpriseName: "", // 企业名称
        mobile: "", // 手机号
        name: "", // 姓名
        catchcode: "", // 图像吗
        password: "", // 密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密
        smsCode: "", // 短信验证码
      },
      countDown: {},
    };
  },
  watch: {
    registerType() {
      this.$refs["registerFormRef"].clearValidate();
    },
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 注册
     * @param
     * @return
     */
    handleregister(formName) {
      if (!this.isProtocol) {
        this.$message({
          message: "请同意协议",
          type: "warning",
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _registerForm = deepCopyRef(this.registerForm);
          _registerForm.password = encryptDES(_registerForm.password);
          ajax.post({
            url: this.registerTypeData[this.registerType].api,
            data: _registerForm,
            self: this,
            success: (res) => {
              if (res) {
                setTimeout(() => {
                  this.push({ path: "/login" });
                }, 1500);
              }
            },
            fail: () => {},
          });
        }
      });
    },
    /**
     * @author 伟健 / 张
     * @name 根据key获取提示
     */
    getMesgText(key) {
      let d = {
        name: "姓名",
        password: "密码",
        smsCode: "短信验证码",
        catchcode: "图像码",
        mobile: "手机号",
        enterpriseName: "企业名称",
        enterpriseCode: "企业统一信用代码",
      };
      return d[key];
    },
    /**
     * @author 伟健 / 张
     * @name 发送短信
     */
    handleSend() {
      if (!this.countDown.checkStatus()) {
        return;
      }

      let hasError = false;
      this.$refs["registerFormRef"].validateField(["mobile", "catchcode"], (err) => {
        if (err) {
          hasError = true;
          return;
        }
      });
      if (!hasError) {
        ajax.post({
          url: "/supplyChain/common/sendSmsCode",
          self: this,
          data: {
            catchcode: this.registerForm.catchcode, // 图形验证码
            mobile: this.registerForm.mobile, // 手机号码
          },
          success: (res) => {
            if (res) {
              this.countDown.start();
            }
          },
          fail: () => {
            this.getcaptcha();
          },
        });
      }
    },
    /**
     * @author 伟健 / 张
     * @name 倒计时
     */
    handleCountDown() {
      this.countDown.start();
    },
    /**
     * @author 伟健 / 张
     * @name 获取图像码
     */
    getcaptcha() {
      ajax.post({
        url: "/supplyChain/common/getcaptcha",
        data: {},
        self: this,
        success: (res) => {
          if (res) {
            this.verificationCode = res;
          }
        },
        fail: () => {},
      });
    },
    /**
     * @author 伟健 / 张
     * @name 用户协议
     */
    getProtocolList() {
      ajax.post({
        url: "/supplyChain/auth/getUserProtocol",
        data: {
          code: 3,
        },
        self: this,
        success: (res) => {
          console.log(res);
          this.protocol = res;
        },
        fail: () => {},
      });
    },
  },
  created() {
    this.countDown = new CountDown({
      self: this,
      /*   这两参数必填
       "CountDownNum": 30,
       "CountDownStatus": true,
       */
      id: "register",
    });
    this.getcaptcha();
    this.getProtocolList();
  },
};
</script>
<style scoped></style>
 <style>.bg-\[\#fff\] {
    background-color: #fff
}
.h-\[100vh\] {
    height: 100vh
}
.pr-\[40\] {
    padding-right: 40px
}
.min-h-\[84vh\] {
    min-height: 84vh
}
.pt-\[100\] {
    padding-top: 100px
}
.w-\[400\] {
    width: 400px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.mb-\[24\] {
    margin-bottom: 24px
}
.t-\[24\] {
    font-size: 24px
}
.t-\[\#192530\] {
    color: #192530
}
.rounded-\[2\] {
    border-radius: 2px
}
.leading-\[32\] {
    line-height: 32px
}
.w-\[80\] {
    width: 80px
}
.border-\[\#dcdfe6\] {
    border-color: #dcdfe6
}
.border-y-\[1px\] {
    border-top-width: 1px;
    border-bottom-width: 1px
}
.border-l-\[1px\] {
    border-left-width: 1px
}
.t-\[\#fff\] {
    color: #fff
}
.bg-\[theme\] {
    background-color: #008AA6
}
.border-\[theme\] {
    border-color: #008AA6
}
.border-r-\[1px\] {
    border-right-width: 1px
}
.t-\[12\] {
    font-size: 12px
}
.t-\[\#a1a1a1\] {
    color: #a1a1a1
}
.leading-\[20\] {
    line-height: 20px
}
.right-\[0\] {
    right: 0px
}
.w-\[164\] {
    width: 164px
}
.w-\[226\] {
    width: 226px
}
.pr-\[10\] {
    padding-right: 10px
}
.w-\[130\] {
    width: 130px
}
.pl-\[10\] {
    padding-left: 10px
}
.w-\[100\%\] {
    width: 100%
}
.h-\[48\] {
    height: 48px
}
.border-l-\[1\] {
    border-left-width: 1px
}
.border-\[\#d5dae5\] {
    border-color: #d5dae5
}
.w-\[100\] {
    width: 100px
}
.leading-\[24\] {
    line-height: 24px
}
.my-\[9\] {
    margin-top: 9px;
    margin-bottom: 9px
}
.t-\[theme\] {
    color: #008AA6
}
.\!t-\[theme\] {
    color: #008AA6 !important
}
.mr-\[5\] {
    margin-right: 5px
}
.mt-\[14\] {
    margin-top: 14px
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}
.cursor-pointer {
    cursor: pointer
}
.justify-between {
    justify-content: space-between
}
.font-500 {
    font-weight: 500
}
.overflow-hidden {
    overflow: hidden
}
.text-center {
    text-align: center
}
.border-solid {
    border-style: solid
}
.relative {
    position: relative
}
.absolute {
    position: absolute
}
.flex-1 {
    flex: 1 1 0%
}
.no-underline {
    text-decoration: none
}</style>